import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  getAllStates: makeAxiosRequest('/all-states', { method: 'get' }, true),
};
